import React from "react";
import { Menu, Icon } from "antd";
import { compose, defaultProps } from "recompose";
import { Link, withRouter } from "react-router-dom";

import styled from "styled-components/macro";

const { Item } = Menu;

const Container = styled(Menu)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  position: sticky;
  top: 64px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 1024px) {
    justify-content: flex-start;
  }

  &.ant-menu-horizontal {
    background: #f8f9fa;
    color: #747c84;
    border-bottom: 0px;
  }

  &.ant-menu-horizontal > .ant-menu-item {
    align-items: center;
    height: 56px;
    background: #f7f9fa;
    width: 180px;
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    border-top-width: 1px !important;
    border-top-color: transparent;
    padding: 0 18px 0 32px;
    transition: 0s;
    a {
      font-size: 15px;
    }
    span {
      font-size: 13px;
    }
    a,
    span {
      align-items: center;
      color: #343a40;
      display: flex;
    }
    .anticon {
      font-size: 16px;
    }
    &:hover {
      transition: 0s;
      background: #f7f9fa;
      a,
      span {
        color: rgba(0, 0, 0, 0.65);
      }
    }
  }

  .ant-menu-horizontal > .ant-menu-item-selected {
    background: #ffffff;
    border-top-color: ${({ theme }) => theme["@primary"]};
  }

  &.ant-menu-horizontal > .ant-menu-item-selected > a,
  &.ant-menu-horizontal > .ant-menu-item-selected > span {
    transition-delay: 0s;
    color: rgba(0, 0, 0, 0.65);
    font-weight: bold;

    .anticon {
      color: ${({ theme }) => theme["@primary"]};
    }
  }
`;

const Nav = ({
  path,
  links = [],
  zIndex = 3,
  menuWidth = "100%",
  staticContext,
  style,
  ...props
}) => {
  return (
    <Container
      selectedKeys={[path]}
      mode="horizontal"
      style={{ width: menuWidth, zIndex, ...style }}
      {...props}
    >
      {links.map(link => (
        <Item key={link.to} data-test={`nav-link-${link.testKey}`}>
          <Link /*onBlur={handleBlur} onFocus={handleFocus}*/ to={link.to}>
            {link.icon && <Icon type={link.icon} />}
            {link.label}
          </Link>
          <span>{link.loading ? <Icon type="loading" /> : link.count}</span>
        </Item>
      ))}
    </Container>
  );
};

const enhancer = compose(
  withRouter,
  defaultProps(({ location }) => ({
    path: location.pathname.split("/").pop()
  }))
);

export default enhancer(Nav);
